import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon, XIcon, WarningIcon } from '../../icons';
import { cn } from '../../utils';
import { ElementIntent } from '../../enums';
const getIntentStyles = (intent) => {
    switch (intent) {
        case ElementIntent.Success:
            return {
                iconBg: 'bg-success',
                iconOutline: 'outline-success-ring',
                iconColor: 'text-success-fg',
                icon: CheckIcon,
            };
        case ElementIntent.Danger:
            return {
                iconBg: 'bg-danger',
                iconOutline: 'outline-danger-ring',
                iconColor: 'text-danger-fg',
                icon: XIcon,
            };
        case ElementIntent.Warning:
            return {
                iconBg: 'bg-warning',
                iconOutline: 'outline-warning-ring',
                iconColor: 'text-warning-fg',
                icon: WarningIcon,
            };
        case ElementIntent.Info:
        default:
            return {
                iconBg: 'bg-info',
                iconOutline: 'outline-info-ring',
                iconColor: 'text-info-fg',
                icon: WarningIcon,
            };
    }
};
export function Toast({ intent, title, message, onDismiss }) {
    const styles = getIntentStyles(intent);
    return (_jsx("div", { className: "bg-surface p-stack-roomy border border-border-subtle rounded-card-sm shadow-popover max-w-prose-sm", children: _jsxs("div", { className: "flex items-center gap-stack", children: [_jsx("div", { className: cn('flex-shrink-0 size-8', 'rounded-surface flex items-center justify-center', styles.iconBg, styles.iconOutline), children: _jsx("span", { className: styles.iconColor, children: _jsx(styles.icon, { className: "size-4" }) }) }), _jsxs("div", { children: [_jsx("p", { className: "text-fg text-body-sm font-semibold", children: title }), _jsx("p", { className: "text-fg-muted text-caption", children: message })] }), _jsx("button", { onClick: onDismiss, className: "p-stack-tight rounded-pill hover:bg-bg-subtle/50", children: _jsx(XIcon, { className: "w-4 h-4 text-fg-subtle" }) })] }) }));
}
